<template>
    <MBase
        :is="buttonComponent"
        button-classes="bg-black text-white border-black disabled:cursor-not-allowed"
        :href="href"
        :is-loading="isLoading"
        :is-disabled="isDisabled"
        :is-small="isSmall"
        :is-large="isLarge"
        :icon="icon"
        @click="$emit('click', $event)"
        ><slot
    /></MBase>
</template>

<script>
import MBase from "./buttons/base";
import MBlack from "./buttons/black";
import MBlue from "./buttons/blue";
import MAqua from "./buttons/aqua";
import MNegative from "./buttons/negative";
import MPositive from "./buttons/positive";
import MWhite from "./buttons/white";
import MYellow from "./buttons/yellow";

export default {
    name: "MButton",
    components: {
        MBase,
        MBlack,
        MBlue,
        MAqua,
        MNegative,
        MPositive,
        MWhite,
        MYellow
    },
    extends: MBase,
    props: {
        colour: {
            type: String,
            default: "blue"
        }
    },
    computed: {
        buttonComponent() {
            const components = {
                black: "MBlack",
                blue: "MBlue",
                aqua: "MAqua",
                negative: "MNegative",
                positive: "MPositive",
                white: "MWhite",
                yellow: "MYellow"
            };
            if (Object.keys(components).includes(this.colour)) {
                return components[this.colour];
            }

            return MBase;
        }
    }
};
</script>

<style scoped lang="scss">
button.button,
a.button {
    -webkit-appearance: none;
}
</style>
